export const getTemplateOptions = (templates) => {
  return templates
    .sort((first, second) => first.name.localeCompare(second.name))
    .map((item) => ({
      label: item?.name,
      value: item?.id,
    })) || [];
};
